import { IModel } from 'app/model/base/annotation';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';

import { driverVersions } from 'app/registries/consts/tabular-consts';
import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { LinkedServiceUtils } from './linked-service.utils';

export const sparkAuthTypes = {
    Anonymous: 'Anonymous',
    Username: 'Username',
    UsernameAndPassword: 'UsernameAndPassword',
    WindowsAzureHDInsightService: 'WindowsAzureHDInsightService'
};

@Metamodel.model({
    name: adfModelTypeMap.spark.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Spark_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.Spark_DisplayText)
    ]
})
export class SparkLinkedService extends LinkedService {

    public static readonly MODEL: IModel;
    @Metamodel.attribute({
        display: stringResources.VersionLabel
    })
    public version?: string = driverVersions.v2;
    @Metamodel.attribute({
        display: stringResources.ModelName_Host
    })
    public host?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Port
    })
    public port?: number;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServerType
    })
    public serverType?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ThriftTransportProtocol
    })
    public thriftTransportProtocol?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AuthenticationType
    })
    public authenticationType?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName
    })
    public username?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public password?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_HttpPath
    })
    public httpPath?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_EnableSSL
    })
    public enableSsl?: boolean;

    @Metamodel.attribute({
        display: stringResources.ModelName_TrustedCertPath
    })
    public trustedCertPath?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UseSystemTrustStore
    })
    public useSystemTrustStore?: boolean;
    @Metamodel.attribute({
        display: stringResources.ModelName_EnableServerCertificateValidation
    })
    public enableServerCertificateValidation?: boolean = true;
    @Metamodel.attribute({
        display: stringResources.ModelName_AllowHostNameCNMismatch
    })
    public allowHostNameCNMismatch?: boolean;

    @Metamodel.attribute({
        display: stringResources.ModelName_AllowSelfSignedServerCert
    })
    public allowSelfSignedServerCert?: boolean;

    constructor(name?: string, description?: string) {
        super(name, description);
        if (__IS_FABRIC_DPE__) {
            this.version = driverVersions.v2;
        }
    }

    public convertV1toV2(context: { inlineDataset?: boolean }): SparkLinkedService {
        return LinkedServiceUtils.commonV1ToV2(context, this) as SparkLinkedService;
    }
}
